<template lang="pug">

  header(v-if="userSession.loggedIn").py-3.px-4

    sos-button(color="transparent" size="regular" buttonLabel="Sair" buttonIcon="mdi-exit-to-app" buttonIconSize="20" @buttonClick="doLogout")

</template>

<!-- ESSE COMPONENTE É CHAMADO NAS TELAS "404" E "JOIN GROUP" -->

<script>

  import { mapState } from 'vuex'

  import SosButton from '@/components/SosButton'

  export default {
    name: 'AppBar',

    components: {
      'sos-button': SosButton,
    },

    computed: {
      ...mapState(['userSession']),
    },

    methods: {
      doLogout: function () {
        // [24/01/25] console.log(':::: CLICOU PARA SAIR NO MENU DA TELA DE CONVITE')

        this.$store.commit('ASK_LOGOUT')
      },
    },
  }

</script>

<style lang="scss" scoped>

  header {
    z-index: 3;
    position: absolute;
    top: 0;
    left: 0;

    display: inline-block;
    width: 100%;
    height: 85px;

    text-align: right;
  }

  @media (max-width: 768px) {
    .sosButton.sosButton--transparent {
      background-color: forestgreen;

      color: #FFFFFF;

      > i {
        color: #FFFFFF;
      }

      &:hover {
        background-color: forestgreen;
        color: #FFFFFF;

        > i {
          color: #FFFFFF;
        }

        .buttonLoader span::before {
          border-top: 1px solid #FFFFFF;
        }
      }

      &:disabled {
        &:hover {
          background-color: forestgreen;

          color: #FFFFFF;

          > i {
            color: #FFFFFF;
          }

          .buttonLoader span::before {
            border-top: 1px solid #FFFFFF;
          }
        }
      }
    }
  }

</style>
